import { Badge as ShadcnBadge, badgeVariants } from "@/components/ui/badge";
import type { VariantProps } from "class-variance-authority";
import * as React from "react";

export interface BadgeProps extends React.HTMLAttributes<HTMLDivElement>, VariantProps<typeof badgeVariants> { }

export function Badge({ className, variant, ...props }: BadgeProps) {
    return <ShadcnBadge className={className} variant={variant} {...props} />;
}

export { badgeVariants };

